<template>
  <div class="container">
    <div class="sites-container">
      <div class="sites-wrapper">
        <div
          v-for="(item, index) in dropdown"
          :key="index"
          class="site"
          @mouseover="showBox = index"
          @mouseleave="showBox = ''"
        >
          {{item.title}}
          <span class="iconfont">&#xe602;</span>
          <div
            v-show="index === showBox"
            class="sub-sites"
          >
            <ul>
              <li
                v-for="(site, index2) in item.list"
                :key="index2"
                :title="site.title"
                @click="toSite(site.url)"
              >
                <span class="iconfont">&#xe603;</span>
                {{site.title}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-container">
      <div class="wrapper">
        <div class="left">
          <ul>
            <li>
              <a href="#">办公OA</a>
            </li>
            <li class="line"></li>
            <li>
              <a href="#">公司介绍</a>
            </li>
            <li class="line"></li>
            <li>
              <a href="#">网站地图</a>
            </li>
            <li class="line"></li>
            <li>
              <a href="#">互动交流</a>
            </li>
            <li class="line"></li>
            <li>
              <a href="#">版权声明</a>
            </li>
            <li class="line"></li>
            <li>
              <a href="#">法律声明</a>
            </li>
          </ul>

          <p class="address">
            地址：成都市青羊区敬业路108号青羊工业园区T区21栋；电话：028-87067387；邮编：610091
          </p>
          <p class="copyright">
            COPYRIGHT(C) 2020四川鼎能建设(集团)有限公司 ALL RIGHTS RESERVED <span class="link" @click="toLink">蜀ICP备14003722号-1</span>
          </p>
        </div>

        <div class="qr-code">
          <img src="/imgs/qr.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalBottom',
  data () {
    return {
      dropdown: [
        {
          title: '政府网站',
          list: [
            {
              title: '中国政务网',
              url: 'http://www.gov.cn/'
            },
            {
              title: '中国国家能源局',
              url: 'http://www.nea.gov.cn/'
            },
            {
              title: '四川省人民政府',
              url: 'http://www.sc.gov.cn/'
            },
            {
              title: '四川省纪委监委网',
              url: 'http://www.scjc.gov.cn/'
            },
            {
              title: '四川省应急管理厅',
              url: 'https://yjt.sc.gov.cn/'
            },
            {
              title: '四川煤矿安全监察局',
              url: 'http://sc.chinacoal-safety.gov.cn/'
            },
            {
              title: '四川省总工会',
              url: 'http://www.scgh.org/'
            },
            {
              title: '四川青年网',
              url: 'http://scgqt.gov.cn/home/'
            }
          ]
        },
        {
          title: '集团网站群',
          list: [
            {
              title: '川煤集团',
              url: 'http://www.cmjt.com.cn'
            },
            {
              title: '鼎能房产',
              url: 'http://www.scdnfc.com/'
            },
            {
              title: '川煤六建',
              url: 'http://sccmlj.com/'
            },
            {
              title: '川南建工',
              url: 'http://www.ybcnjg.cn/'
            },
            {
              title: '路桥公司',
              url: 'http://www.scdnlq.cn/'
            },
            {
              title: '鼎能鑫盛达',
              url: 'http://www.scdnxsd.com/'
            }
          ]
        },
        {
          title: '新闻媒体',
          list: [
            {
              title: '人民日报',
              url: 'http://www.people.com.cn/'
            },
            {
              title: '中国青年报',
              url: 'http://zqb.cyol.com/html/2020-12/01/nbs.D110000zgqnb_01.htm'
            },
            {
              title: '中国法制报',
              url: 'http://www.legaldaily.com.cn/'
            },
            {
              title: '中国能源报',
              url: 'http://paper.people.com.cn/zgnyb/html/2020-06/01/node_2222.htm'
            },
            {
              title: '中国煤炭报',
              url: 'http://www.ccoalnews.com/'
            },
            {
              title: '中国矿业报',
              url: 'http://www.zgkyb.com/'
            },
            {
              title: '四川日报',
              url: 'https://epaper.scdaily.cn/'
            },
            {
              title: '四川科技报',
              url: 'http://sckjwb.ihwrm.com/'
            }
          ]
        }
      ],
      showBox: ''
    }
  },
  methods: {
    toSite (url) {
      window.open(url)
    },
    toLink () {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style scoped>
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}

.sites-container {
  width: 100%;
  height: 100px;
  background-color: rgb(26, 58, 119);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sites-wrapper {
  width: 1290px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.site {
  width: 312px;
  color: #ffffff;
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border: 2px solid #ffffff;
  font-size: 14px;
}

.sub-sites {
  position: absolute;
  top: 34px;
  left: -2px;
  background-color: rgb(106, 150, 182);
  z-index: 999;
  box-sizing: border-box;
}

.sub-sites ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sub-sites ul li {
  width: 45%;
  padding: 14px 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.sub-sites ul li:hover {
  color: #aaaaaa;
  cursor: pointer;
}

.bottom-container {
  height: 140px;
  width: 100%;
  padding: 0 10px;
  background-color: rgb(18, 41, 91);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.wrapper {
  width: 1290px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.left {
  width: 50%;
  margin-top: 40px;
  font-size: 14px;
}

.left ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left .line {
  height: 12px;
  width: 1px;
  background-color: #fff;
}

.left a {
  color: #ffffff;
  text-decoration: none;
}

.left p {
  color: #ffffff;
  font-size: 14px;
}

.left .address {
  margin-top: 20px;
}

.left .copyright {
  margin-top: 10px;
}

.qr-code {
  margin-top: 24px;
  margin-right: 20px;
}

.qr-code img {
  height: 100px;
}
</style>
